module.exports = __webpack_public_path__ + "media/images/emblems/Mauraz-coat_of_arms-b6339e59cf7772c7283761482a299110.svg";